module.exports = "./assets/images/avatar-11.svg";